import store from "@/store";

const routes = [
  {
    path: "/accounting/banks/:id",
    name: "acctbanks",
    component: () => import("@/views/main/modules/Accounting/Views/BanksView.vue"),
    beforeEnter: (to, from, next) => {
      store
        .dispatch("checkAccessUser", to.params.id)
        .then((response) => {
          if (response == "fail") {
            next("/no-access");
          } else {
            next();
          }
        })
        .catch(() => {});
    },
    meta: {
      requiresAuth: true,
      title: "Banks",
    },
  },
];

export default routes;
